// extracted by mini-css-extract-plugin
export var carrierTab = "_47-0";
export var carrierTabActive = "_47-1 _47-0";
export var carrierTabInactive = "_47-2 _47-0";
export var carrierTabLabel = "_47-3";
export var carrierTabLabelActive = "_47-4 _47-3";
export var carrierTabLabelInactive = "_47-5 _47-3";
export var carrierTabPercentage = "_47-6";
export var carrierTabPercentageActive = "_47-7 _47-6";
export var carrierTabPercentageInactive = "_47-8 _47-6";
export var carrierTabWinnable = "_47-9";
export var carrierTabWinnableActive = "_47-a _47-9";
export var carrierTabWinnableInactive = "_47-b _47-9";
export var comparisonContainer = "_47-d";
export var missingRateButton = "_47-n";
export var missingRateButtonActive = "_47-o _47-n";
export var missingRateButtonInactive = "_47-p _47-n";
export var missingRateButtonLabel = "_47-q";
export var missingRateButtonLabelActive = "_47-r _47-q";
export var missingRateButtonLabelInactive = "_47-s _47-q";
export var sidebar = "_47-c";
export var strategyButton = "_47-e";
export var strategyButtonActive = "_47-f _47-e";
export var strategyButtonDescription = "_47-k";
export var strategyButtonDescriptionActive = "_47-l _47-k";
export var strategyButtonDescriptionInactive = "_47-m _47-k";
export var strategyButtonInactive = "_47-g _47-e";
export var strategyButtonLabel = "_47-h";
export var strategyButtonLabelActive = "_47-i _47-h";
export var strategyButtonLabelInactive = "_47-j _47-h";
export var unitToggleButton = "_47-t";
export var unitToggleButtonActive = "_47-u _47-t";
export var unitToggleButtonInactive = "_47-v _47-t";
export var unitToggleButtonLabel = "_47-w";
export var unitToggleButtonLabelActive = "_47-x _47-w";
export var unitToggleButtonLabelInactive = "_47-y _47-w";